import { useId, useState } from 'react';
import styles from './InfoTip.module.css';
import infoIcon from '@/assets/icons/info-i.svg';

/**
 * Column definition on hover or focus. Copy comes from the API's field
 * dictionary so the dashboard explains a metric the same way the MCP does —
 * one definition, two surfaces.
 */
export function InfoTip({ text, formula }: { text: string; formula?: string }) {
  const [open, setOpen] = useState(false);
  const id = useId();

  return (
    <span className={styles.wrap}>
      <span
        className={styles.trigger}
        tabIndex={0}
        role="button"
        aria-label="What this means"
        aria-describedby={open ? id : undefined}
        onMouseEnter={() => { setOpen(true); }}
        onMouseLeave={() => { setOpen(false); }}
        onFocus={() => { setOpen(true); }}
        onBlur={() => { setOpen(false); }}
      >
        <img className={styles.icon} src={infoIcon} alt="" />
      </span>
      {open && (
        <span className={styles.bubble} id={id} role="tooltip">
          {text}
          {formula && <span className={styles.formula}>{formula}</span>}
        </span>
      )}
    </span>
  );
}
